import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { ManageReturnsTable } from './ManageReturnsTable'
import { Chip, Tooltip } from '@material-tailwind/react'
import { AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline'
import ManageOrdersTable from './ManageOrdersTable'
import ManageInventoryTable from './ManageInventoryTable'
import AppShell from '../../../../Components/AppShell'
import PageHeader from '../../../../Components/PageHeader'

const RefProcessView = () => {
  const params = useParams()
  const [currentTable, setCurrentTable] = useState('returns')
  const [isHovered, setIsHovered] = useState(false)
  const [category, setCategory] = useState()

  useEffect(() => {
    axios
      .get(`/api/refund-audits/get/${params.id}`)
      .then((response) => {
        if (response.data.message) {
          console.log('Cannot get batches')
        } else {
          setCategory(response.data.result.categories[0])
        }
      })
      .catch((error) => {
        console.error('Error:', error)
      })
  }, [params.id])

  return (
    <AppShell>
      <PageHeader
        kicker="Warehouse"
        title="Refund actions"
        subtitle="Process returns, orders, and inventory for this batch."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Warehouse', to: '/warehouse-tools' },
          { label: 'Refunds', to: '/warehouse-tools/warehouse-refunds' },
          { label: params.id },
        ]}
        status={
          <div className="flex flex-wrap items-center gap-2">
            <Chip variant="gradient" color="purple" value={`Batch ID: ${params.id}`} />
            <Chip variant="gradient" color="teal" value={`Category: ${category || '…'}`} />
            {category === 'all' && (
              <div className="relative">
                <Tooltip content="Switch table">
                  <button
                    type="button"
                    className="nx-btn-ghost p-1.5"
                    onClick={() => setIsHovered((prevstate) => !prevstate)}
                    aria-expanded={isHovered}
                  >
                    <AdjustmentsHorizontalIcon className="h-6 w-6 text-signal" />
                  </button>
                </Tooltip>
                {isHovered && (
                  <div className="absolute right-0 top-10 z-20 flex w-48 flex-col gap-1 rounded-lg border border-rule bg-raised p-2 shadow-panel">
                    <button
                      type="button"
                      onClick={() => setCurrentTable('returns')}
                      className="nx-btn-ghost justify-start"
                    >
                      Manage returns
                    </button>
                    <button
                      type="button"
                      onClick={() => setCurrentTable('orders')}
                      className="nx-btn-ghost justify-start"
                    >
                      Manage orders
                    </button>
                    <button
                      type="button"
                      onClick={() => setCurrentTable('inventory')}
                      className="nx-btn-ghost justify-start"
                    >
                      Manage inventory
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        }
      />

      <div className="nx-panel overflow-hidden p-2 sm:p-4">
        {category === 'all' ? (
          currentTable === 'returns' ? (
            <ManageReturnsTable batchId={params.id} />
          ) : currentTable === 'orders' ? (
            <ManageOrdersTable batchId={params.id} />
          ) : currentTable === 'inventory' ? (
            <ManageInventoryTable batchId={params.id} />
          ) : null
        ) : null}
      </div>
    </AppShell>
  )
}

export default RefProcessView
